<template>
  <el-dialog
    :title="$t('newApp.Attribute.dcoa')"
    :visible.sync="dialogVisible"
    width="1000px"
    class="costConfirmDialog"
    @close="dialogCloseHandle"
  >
    <div class="common_readonly_template">
      <el-row>
        <el-col :span="12">
          <div>
            <div class="label">{{$t('newApp.BasicInfo.an')}}</div>
            <div class="text">{{ costConfirmData.activityCode }}</div>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <div class="label">{{$t('newApp.Attribute.cad')}}</div>
            <div class="text">{{ costConfirmData.deptName }}</div>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <div class="label">{{$t('newApp.Attribute.toe')}}</div>
            <div class="text">{{ costConfirmData.expenseTypeName }}</div>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <div v-if="callbackUrl !== '/industryReportDetails' && callbackUrl !== '/regionReportDetails'" class="label">{{$t('newApp.Attribute.ac')}}</div>
            <div v-else class="label">{{ $t('newApp.Attribute.bbje') }}</div>
            <div class="text">{{ costConfirmData.activityMoney }}</div>
          </div>
        </el-col>
        <el-col v-if="callbackUrl !== '/industryReportDetails' && callbackUrl !== '/regionReportDetails'" :span="12">
          <div>
            <div class="label">{{$t('newApp.Attribute.coam')}}</div>
            <div class="text">{{ costConfirmData.advertisingCost }}</div>
          </div>
        </el-col>
        <el-col v-if="callbackUrl !== '/industryReportDetails' && callbackUrl !== '/regionReportDetails'" :span="12">
          <div>
            <div class="label">{{$t('newApp.Attribute.aa')}}</div>
            <div class="text">{{ costConfirmData.costTotal }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="describe">
      {{$t('notic.zhinfo')}}
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogCloseHandle">{{$t('btn.Cancel')}}</el-button>
      <el-button type="primary" @click="submitHandle">{{$t('btn.OK')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false,
      formData: {},
      callbackUrl: ''
    };
  },
  props: {
    costConfirmDialogVisible: {
      type: Boolean,
      default: false
    },
    costConfirmData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    costConfirmDialogVisible (val) {
      if (val) {

      }
      this.dialogVisible = val;
    }
  },
  mounted () {
    this.callbackUrl = this.$route.query.callback;
  },
  methods: {
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    },
    submitHandle () {
      this.$emit('submitHandle');
    }
  }

};
</script>

<style lang="scss" scoped>
.costConfirmDialog{
  .describe{
    margin-top: 20px;
    line-height: 30px;
    color: #909399;
  }
}
</style>
